import { WatchfaceDeviceType } from './use-watchface-devices';
import { ElectronApi } from '@/services/electron.api';

export interface JumpAppItem {
  name: string;
  appid: string;
  /**
   * 中文名称
   */
  label: string;
  excludeDevice?: WatchfaceDeviceType[];
  includeDevice?: WatchfaceDeviceType[];
}

export const jumpAppList_professional: JumpAppItem[] = [
  // 远程拍照和遥控拍照相同，名字不同，O63之后的设备支持
  {
    name: 'remoteCamera',
    appid: '0x001C',
    label: '遥控拍照',
    includeDevice: [
      'N66',
      'N67',
      'O61',
      'P65',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'sms',
    appid: '0x0046',
    label: '信息',
    includeDevice: ['O61', 'P62', 'Q61']
  },
  {
    name: 'miJia',
    appid: '0x003F',
    label: '米家',
    includeDevice: [
      'N66',
      'N67',
      'O63',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'todo',
    appid: '0x003C',
    label: '待办',
    includeDevice: [
      'N66',
      'N67',
      'O61',
      'O63',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  // 妙享中心和融合设备中心相同，名称不同，O63之后的设备支持
  {
    name: 'share',
    appid: '0x0031',
    label: '融合设备中心',
    includeDevice: [
      'N66',
      'N67',
      'P65',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'amap',
    appid: '0x0047',
    label: '地图',
    includeDevice: ['N62S', 'Q61']
  },
  {
    name: 'navigation',
    appid: '0x0048',
    label: '导航',
    includeDevice: ['N62S', 'Q61']
  },
  {
    name: 'research',
    appid: '0x0051',
    label: '健康研究',
    includeDevice: ['O61', 'O63', 'Q61', 'Q63', 'P62']
  },
  // 对讲从O62开始支持
  {
    name: 'intercom',
    appid: '0x004E',
    label: '对讲',
    excludeDevice: [
      'L61Simulator',
      'L61',
      'L67',
      'M67',
      'M62',
      'M65S',
      'M66',
      'N60',
      'N65',
      'N62',
      'N62S',
      'N66',
      'N65A',
      'N65B',
      'N65C',
      'N67',
      'O66',
      'P67',
      'Q66'
    ]
  },
  {
    name: 'ECG',
    appid: '0x0035',
    label: '移动心电房颤提示软件',
    includeDevice: ['O61', 'Q61']
  },
  {
    name: 'interconnect',
    appid: '0x0043',
    label: '多端联动',
    includeDevice: ['O61', 'P62', 'P65', 'P67', 'Q61', 'Q63']
  },
  {
    name: 'micar',
    appid: '0x00FF',
    label: '小米汽车',
    includeDevice: ['O61', 'P62', 'Q61', 'Q63']
  },
  {
    name: 'watchfaceMarket',
    appid: '0x00FF',
    label: '表盘商店',
    includeDevice: ['O61', 'Q61']
  },
  {
    name: 'appsMarket',
    appid: '0x00FF',
    label: '应用商店',
    includeDevice: ['O61', 'Q61']
  },
  {
    name: 'weightManagement',
    appid: '0x005D',
    label: '体重管理',
    includeDevice: ['Q61']
  },
  {
    name: 'healthSummary',
    appid: '0x005F',
    label: '健康摘要',
    includeDevice: ['Q61']
  }
];

export const jumpAppList: JumpAppItem[] = [
  {
    name: 'pressure',
    appid: '0x0003',
    label: '压力'
  },
  {
    name: 'breath',
    appid: '0x0004',
    label: '呼吸训练'
  },
  {
    name: 'heartrate',
    appid: '0x0005',
    label: '心率'
  },
  {
    name: 'sleep',
    appid: '0x000C',
    label: '睡眠'
  },
  {
    name: 'SpO2',
    appid: '0x000E',
    label: '血氧'
  },
  {
    name: 'sport',
    appid: '0x000F',
    label: '运动'
  },
  {
    name: 'activities',
    appid: '0x0013',
    label: '活力指标'
  },
  {
    name: 'media',
    appid: '0x0015',
    label: '音乐'
  },
  {
    name: 'settings',
    appid: '0x0016',
    label: '设置'
  },
  // 电量是设置的二级菜单，所以appid相同，用args区分
  {
    name: 'battery',
    appid: '0x0016',
    label: '电量',
    includeDevice: ['O61', 'P67', 'Q61']
  },
  {
    name: 'compass',
    appid: '0x0018',
    label: '指南针',
    excludeDevice: ['N66']
  },
  {
    name: 'flashlight',
    appid: '0x001A',
    label: '手电筒'
  },
  {
    name: 'calendar',
    appid: '0x001B',
    label: '日程',
    excludeDevice: ['N67']
  },
  // 远程拍照和遥控拍照相同，名字不同，早期设备用远程拍照
  {
    name: 'remoteCamera',
    appid: '0x001C',
    label: '远程拍照',
    excludeDevice: [
      'N66',
      'N67',
      'O61',
      'O63',
      'P65',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'sportsRecord',
    appid: '0x001D',
    label: '运动记录'
  },
  {
    name: 'alipay',
    appid: '0x001E',
    label: '支付宝',
    excludeDevice: []
  },
  {
    name: 'womenHealth',
    appid: '0x001F',
    label: '女性健康'
  },
  {
    name: 'chronograph',
    appid: '0x0020',
    label: '秒表'
  },
  {
    name: 'weather',
    appid: '0x0021',
    label: '天气'
  },
  {
    name: 'phone',
    appid: '0x0023',
    label: '电话',
    excludeDevice: ['N66', 'N67', 'O66', 'P67', 'Q66']
  },
  {
    name: 'wxpay',
    appid: '0x0025',
    label: '微信支付',
    excludeDevice: ['Q61']
  },
  {
    name: 'timer',
    appid: '0x0026',
    label: '倒计时'
  },
  {
    name: 'findPhone',
    appid: '0x0027',
    label: '找手机'
  },
  {
    name: 'alarm',
    appid: '0x0028',
    label: '闹钟'
  },
  {
    name: 'recorder',
    appid: '0x0029',
    label: '录音机',
    excludeDevice: ['N66', 'N67']
  },
  {
    name: 'barometer',
    appid: '0x002A',
    label: '气压计',
    excludeDevice: ['N66', 'N67', 'P65', 'O66', 'P67', 'Q66']
  },
  {
    name: 'nfcCard',
    appid: '0x002B',
    label: '卡包'
  },
  // O61 Q61-超级小爱，其他-小爱同学
  {
    name: 'voiceAssistant',
    appid: '0x002D',
    label: '小爱同学',
    excludeDevice: ['O61', 'Q61']
  },
  {
    name: 'voiceAssistant',
    appid: '0x002D',
    label: '超级小爱',
    includeDevice: ['O61', 'Q61']
  },
  {
    name: 'contact',
    appid: '0x002E',
    label: '常用联系人',
    excludeDevice: ['N66', 'N67', 'O66', 'P67', 'Q66']
  },
  {
    name: 'sportsCourse',
    appid: '0x002F',
    label: '跑步课程'
  },
  {
    name: 'temperature',
    appid: '0x0030',
    label: '温度',
    excludeDevice: [
      'N66',
      'N67',
      'P65',
      'P62',
      'O66',
      'P67',
      'O61',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  // 妙享中心和融合设备中心相同，名称不同，早期设备用妙享中心
  {
    name: 'share',
    appid: '0x0031',
    label: '妙享中心',
    excludeDevice: [
      'N66',
      'N67',
      'O61',
      'O63',
      'P65',
      'P62',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'bloodPressure',
    appid: '0x0034',
    label: '血压',
    excludeDevice: [
      'N66',
      'N67',
      'P65',
      'P62',
      'O63',
      'O66',
      'P67',
      'O61',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'ECG',
    appid: '0x0035',
    label: '心电',
    excludeDevice: [
      'N66',
      'N67',
      'P65',
      'P62',
      'O63',
      'O66',
      'O61',
      'Q61',
      'P67',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'vitalityValue',
    appid: '0x0036',
    label: '元气值',
  },
  {
    name: 'jsApplication',
    appid: '0x0037',
    label: 'JS应用',
    excludeDevice: [
      'N66',
      'N67',
      'O63',
      'O61',
      'P62',
      'P65',
      'O66',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'luaApplication',
    appid: '0x0038',
    label: 'Lua应用',
    excludeDevice: [
      'N66',
      'N67',
      'O63',
      'O61',
      'P65',
      'O66',
      'P62',
      'P67',
      'Q61',
      'Q63',
      'Q66'
    ]
  },
  {
    name: 'trainingStatus',
    appid: '0x0039',
    label: '训练状态',
    excludeDevice: ['N67', 'O63', 'O66']
  },
  {
    name: 'worldclock',
    appid: '0x003B',
    label: '世界时钟'
  },
  {
    name: 'perpetualcalendar',
    appid: '0x0045',
    label: '日历'
  },
  {
    name: 'wechat',
    appid: '0x00FF',
    label: '微信',
    includeDevice: ['O61', 'O63', 'Q61', 'Q63', 'P65', 'P62','Q66']
  },
  {
    name: 'healthScan',
    appid: '0x0057',
    label: '健康扫描',
    includeDevice: ['Q61', 'P62', 'Q63']
  },
  {
    name: 'uvSensor',
    appid: '0x005E',
    label: '紫外线UV',
    excludeDevice: ['L61', 'L67', 'M62', 'M65S', 'M66', 'M67', 'N60', 'N62', 'N62S', 'N65', 'N65A', 'N65B', 'N65C', 'N66', 'N67', 'O62', 'O62M', 'O63', 'O65', 'O65M', 'O66', 'P65']
  },
  ...jumpAppList_professional,
  {
    name: 'none',
    appid: '',
    label: '无',
    excludeDevice: ['N66', 'N67', 'O63']
  },
  {
    name: 'customName',
    appid: '',
    label: '自定义名称',
    includeDevice:
      ElectronApi.isStaging() && ElectronApi.isProfessional()
        ? ['O61', 'P62', 'P65', 'P67', 'Q61']
        : ElectronApi.isProfessional()
        ? ['O61', 'P62', 'P65', 'P67', 'Q61']
        : []
  }
];

export const getAvailableJumpAppList = (
  deviceType: WatchfaceDeviceType
): JumpAppItem[] => {
  const allApps = [...jumpAppList];

  return allApps.filter((app) => {
    const { excludeDevice, includeDevice, name } = app;
    // 如果在排除设备列表中，则不可用
    if (excludeDevice?.includes(deviceType)) {
      return false;
    }
    // 如果包含设备列表为空且名称为customName，则不可用
    if (!includeDevice?.length && name === 'customName') {
      return false;
    }
    // 如果有包含设备列表且当前设备不在列表中，则不可用
    if (
      includeDevice &&
      includeDevice.length > 0 &&
      !includeDevice.includes(deviceType)
    ) {
      return false;
    }

    return true;
  });
};
